/** Estilos e wrappers reutilizáveis dos campos do formulário de cliente. */

export const fieldInputClass =
  'w-full rounded-2xl border border-ink/10 bg-white/90 px-4 py-2.5 text-sm outline-none transition focus:border-accent focus:ring-2 focus:ring-accent/20 dark:border-white/10 dark:bg-white/10';

export const fieldLabelClass = 'mb-1 block text-xs font-medium text-ink/60 dark:text-frost-muted';

/**
 * Wrapper de campo com rótulo opcional.
 * @param {{ label?: string, htmlFor?: string, className?: string, children: import('react').ReactNode }} props
 */
export function Field({ label, htmlFor, className = '', children }) {
  return (
    <div className={className}>
      {label ? (
        <label htmlFor={htmlFor} className={fieldLabelClass}>
          {label}
        </label>
      ) : null}
      {children}
    </div>
  );
}

/**
 * Input de texto controlado já com os estilos padrão.
 * @param {{ value: string, onChange: (v: string) => void } & import('react').InputHTMLAttributes<HTMLInputElement>} props
 */
export function TextInput({ value, onChange, className = '', ...rest }) {
  return (
    <input
      className={`${fieldInputClass} ${className}`.trim()}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    />
  );
}

/**
 * Textarea controlada já com os estilos padrão.
 * @param {{ value: string, onChange: (v: string) => void } & import('react').TextareaHTMLAttributes<HTMLTextAreaElement>} props
 */
export function TextArea({ value, onChange, className = '', ...rest }) {
  return (
    <textarea
      className={`${fieldInputClass} min-h-[72px] resize-y ${className}`.trim()}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    />
  );
}
